module.exports = __webpack_public_path__ + "static/media/paymentsInactive.44f8e06e.svg";